import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { CSVLink } from 'react-csv';
import { colors } from '@material-ui/core';

import { Search, Filter } from './components';
import { hasPermission } from '../../utils/permissions';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  search: {
    flexGrow: 1,
    maxWidth: 480,
    flexBasis: 480
  },
  filterButton: {
    marginLeft: 'auto'
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  }
}));

const UserFilter = props => {
  const {
    onFilter,
    isreadyfordownload,
    onPrepare,
    headervalues,
    onSearch,
    masters,
    className,
    csvHeaders,
    csvFilename,
    ...rest
  } = props;

  const canDownload = hasPermission('export_result');
  const classes = useStyles();

  const [openFilter, setOpenFilter] = useState(false);

  const handleFilterOpen = () => {
    setOpenFilter(true);
  };

  const handleFilterClose = () => {
    setOpenFilter(false);
  };

  const downloadHeaders = Array.isArray(csvHeaders) && csvHeaders.length
    ? csvHeaders
    : (Array.isArray(headervalues) && headervalues.length
      ? headervalues
      : [
          { label: 'User ID', key: 'id' },
          { label: 'Name', key: 'name' },
          { label: 'Company Name', key: 'companyname' },
          { label: 'Mobile Number', key: 'mobilenumber' },
          { label: 'Email', key: 'email' },
          { label: 'City', key: 'city' },
          { label: 'User Commodity', key: 'commodities' },
          { label: 'District', key: 'district' },
          { label: 'State', key: 'state' },
          { label: 'Platform', key: 'platform' },
          { label: 'Language', key: 'preferredlang' },
          { label: 'Version', key: 'version' },
          { label: 'Last Login', key: 'last_login' },
          { label: 'Member Since', key: 'createdAt' },
        ]);

  return (
    <Grid
      {...rest}
      className={clsx(classes.root, className)}
      container
      spacing={3}
    >
      <Grid item xs={6}>
        <Search
          className={classes.search}
          onSearch={onSearch}
          placeholder={"Search by name, mobile"}
        />
      </Grid>
      <Grid item   >
      {canDownload ? (isreadyfordownload ?
        <Button
          className={classes.filterButton}
          color="primary"
          size="small"
          variant="outlined"
        >
        
         <CSVLink
                    headers={downloadHeaders}
                    data={props?.data}
                    filename={csvFilename || 'user-detail'}
                    style={{ "textDecoration": "none", "color": colors.teal[700] }}
                >
           {`Download ${props?.data?.length}`}
                </CSVLink> 
        </Button> : 
        <Button
          className={classes.filterButton}
          color="primary"
          size="small"
          variant="outlined"
          onClick={onPrepare}
        >
          Prepare for Download
          </Button>) : null}
      </Grid>
      <Grid item   >
        <Button
          className={classes.filterButton}
          color="primary"
          onClick={handleFilterOpen}
          size="small"
          variant="outlined"
        >
          <FilterListIcon className={classes.filterIcon}  /> Advance filters
        </Button>
      </Grid>
      <Filter
        onClose={handleFilterClose}
        onFilter={onFilter}
        open={openFilter}
        masters={masters}
      />
    </Grid>
  );
};

UserFilter.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  onSearch: PropTypes.func,
  masters: PropTypes.object
};

export default UserFilter;
